import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import {
	centralInvoiceRecipientQueries,
} from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientQueries.ts";
import type {
	CentralInvoiceRecipient,
} from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientTypes.ts";
import CreateOrUpdateCentralInvoiceRecipientForm
	from "~/modules/client/components/centralInvoiceRecipient/components/CreateOrUpdateCentralInvoiceRecipientForm.tsx";

type UpdateInvoiceRecipientSidebarProps = {
	invoiceRecipientData: CentralInvoiceRecipient | null;
	isOpen: boolean;
	onClose: () => void;
};

const UpdateCentralInvoiceRecipientSidebar = ({
	invoiceRecipientData,
	isOpen,
	onClose,
}: UpdateInvoiceRecipientSidebarProps) => {
	const queryClient = useQueryClient();

	const handleSuccess = useCallback(async () => {
		if (!invoiceRecipientData) return;
		await queryClient.refetchQueries({ queryKey: centralInvoiceRecipientQueries.byClient(invoiceRecipientData.clientId).queryKey });
		await queryClient.invalidateQueries({ queryKey: centralInvoiceRecipientQueries.all().queryKey });
		onClose();
	}, [invoiceRecipientData, onClose, queryClient]);
	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			<>
				{!!invoiceRecipientData && <CreateOrUpdateCentralInvoiceRecipientForm
					initialValues={invoiceRecipientData}
					clientId={invoiceRecipientData.clientId}
					onSuccess={handleSuccess}
					onCancelClick={onClose} />}
			</>
		</Sidebar>
	);
};

export default UpdateCentralInvoiceRecipientSidebar;